@use '../../../../../styles/Constants.scss' as Constants;
@use '../../../../../styles/Colors.scss' as Colors;

.credential-container {
	padding: Constants.$val-spacing-m Constants.$val-spacing-m;;
}

.section-title {
	text-transform: uppercase;
	padding: Constants.$val-spacing-m Constants.$val-spacing-m;;
}

.name-cell {
	padding: Constants.$val-spacing-xs Constants.$val-spacing-m Constants.$val-spacing-xs Constants.$val-spacing-m;
}

.table-title-row {
	z-index: 0;
}
.calendar-icon {
	color: Colors.$col-blackDark;
}
